/**
 * מערכת הטבעות / רקמות — מחליפה את התוסף Zepto Product Personalizer.
 *
 * שני חלקים:
 * 1. <personalization-form> — רכיב בעמוד המוצר: הפעלת השדות, ולידציה (30+ יח' לדפוס,
 *    עד 15 אותיות לספרים), ויצירת מפתח קישור (_pers_key) בין המוצר לשורת העמלה.
 * 2. מנוע סנכרון סל גלובלי — שומר שבכל רגע שורות העמלה (מוצר personalization-fee,
 *    מסוג SETUP_COST) תואמות למוצרים המותאמים בסל: הוספה, כמות, ומחיקת יתומים.
 *    תומך גם בשורות מהמערכת הישנה (מאפיין pc_ref).
 */
(function () {
  'use strict';

  var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)/;

  /* ------------------------------------------------------------------ */
  /* עמוד מוצר                                                           */
  /* ------------------------------------------------------------------ */

  var MESSAGES = {
    minQuantityPrint: function (min) {
      return 'הטבעה זמינה בהזמנה של ' + min + ' יחידות ומעלה. הגדילו את הכמות או בטלו את ההטבעה.';
    },
    insufficientStock: function (min, stock) {
      return 'לא ניתן להזמין עם הטבעה: נדרשות לפחות ' + min + ' יחידות אך במלאי נותרו רק ' + stock + '. ניתן להזמין ללא הטבעה, או ליצור קשר.';
    },
    removedFromCart: function (min) {
      return 'פריט עם הטבעה הוסר מהסל: הטבעה דורשת מינימום ' + min + ' יחידות ואין מספיק מלאי.';
    },
    missingText: {
      print: 'נא למלא את ההקדשה להטבעה.',
      book: 'נא למלא את השם להטבעה.',
      set: 'נא למלא את השם להטבעה.',
      embroidery: 'נא למלא את השם לרקמה.'
    },
    feeSetupMissing: 'אפשרות ההתאמה אינה זמינה כרגע למוצר זה. נסו לרענן או פנו אלינו.'
  };

  var PersonalizationForm = (function () {
    function attach(root) {
      var formId = root.dataset.formId;
      var group = root.dataset.group;
      var minQuantity = parseInt(root.dataset.minQuantity, 10) || 1;

      var textInput = root.querySelector('.personalization__text-input');
      var extraInputs = root.querySelectorAll('.personalization__extra-input');
      var colorInputs = root.querySelectorAll('.personalization__color-input');
      var fileInput = root.querySelector('.personalization__file-input');
      var dateValue = root.querySelector('.personalization__date-value');

      var inventory = {};
      var inventoryEl = root.querySelector('.personalization__inventory');
      if (inventoryEl) {
        try { inventory = JSON.parse(inventoryEl.textContent); } catch (e) { inventory = {}; }
      }

      // רקמה: תצורה לפי הווריאנט (מידה) הנבחר
      var embConfig = null;
      var embConfigEl = root.querySelector('.personalization__emb-config');
      if (embConfigEl) {
        try { embConfig = JSON.parse(embConfigEl.textContent); } catch (e) { embConfig = null; }
      }
      var embItems = root.querySelectorAll('.personalization__emb-item');
      var embInputs = root.querySelectorAll('.personalization__emb-input');
      var phoneControl = root.querySelector('.personalization__phone-control');
      var phoneInput = root.querySelector('.personalization__phone-input');
      var methodWrap = root.querySelector('.personalization__method');
      var methodInputs = root.querySelectorAll('.personalization__method-input');
      var embPriceEl = root.querySelector('.personalization__emb-price');
      var embTitlePriceEl = root.querySelector('.personalization__emb-title-price');
      var feeVariantInput = root.querySelector('input[name="properties[_pers_fee_variant]"]');
      var qtyModeInput = root.querySelector('input[name="properties[_pers_fee_qty_mode]"]');
      var lettersInput = root.querySelector('input[name="properties[_pers_letters]"]');
      var errorEl = root.querySelector('.personalization__error');
      var hiddenInputs = root.querySelectorAll('input[type="hidden"]');
      var keyInput = root.querySelector('input[name="properties[_pers_key]"]');
      var form = document.getElementById(formId);
      if (!form || !textInput) return;

      var qtyInput =
        document.getElementById(formId + '-quantity') ||
        document.querySelector('input[name="quantity"][form="' + formId + '"]');
      var originalMin = qtyInput ? qtyInput.getAttribute('min') : null;

      function embVariantConf() {
        if (!embConfig) return null;
        var vid = form.id && form.id.value ? String(form.id.value) : '';
        if (embConfig[vid]) return embConfig[vid];
        var keys = Object.keys(embConfig);
        return keys.length ? embConfig[keys[0]] : null;
      }

      function embMethod() {
        var conf = embVariantConf();
        if (conf && conf.mode === 'emboss') return 'emboss';
        if (conf && conf.mode === 'choice') {
          var checked = root.querySelector('.personalization__method-input:checked');
          if (checked && checked.value === 'הטבעה') return 'emboss';
        }
        return 'embroidery';
      }

      function embVisibleInputs() {
        var conf = embVariantConf();
        var count = conf ? conf.items : 1;
        if (embMethod() === 'emboss') count = 1;
        var visible = [];
        for (var i = 0; i < embInputs.length && i < count; i++) visible.push(embInputs[i]);
        return visible;
      }

      // ספירת אותיות לחיוב — רווחים לא נספרים; טלפון בגב נספר גם הוא
      function embCountLetters() {
        var total = 0;
        embVisibleInputs().forEach(function (input) {
          total += input.value.replace(/\s+/g, '').length;
        });
        if (phoneInput && phoneControl && !phoneControl.hidden) {
          total += phoneInput.value.replace(/\s+/g, '').length;
        }
        return total;
      }

      // עדכון הטופס לפי המידה הנבחרת: מספר שדות, טלפון בגב, מחיר ושיטה
      function refreshEmbroidery() {
        if (group !== 'embroidery' || !embConfig) return;
        var conf = embVariantConf();
        if (!conf) return;
        var method = embMethod();

        if (methodWrap) methodWrap.hidden = conf.mode !== 'choice';

        var count = method === 'emboss' ? 1 : conf.items;
        embItems.forEach(function (el, i) { el.hidden = i >= count; });
        if (phoneControl) phoneControl.hidden = true;
        if (phoneControl && conf.phone && method === 'embroidery') phoneControl.hidden = false;

        // תוויות ושמות מאפיינים לפי המידה: בגדלים 5 ו-8 כל פריט מקבל שם ייעודי
        var labels, names;
        if (method === 'emboss') {
          labels = ['שם להטבעה (עד 15 אותיות)'];
          names = ['properties[שם להטבעה]'];
        } else if (count === 1) {
          labels = ['שם לרקמה'];
          names = ['properties[שם לרקמה]'];
        } else if (count === 2) {
          labels = [
            'תיק טלית - שם לרקמה',
            'תיק תפילין - שם לרקמה (ראשי תיבות)'
          ];
          names = [
            'properties[תיק טלית - שם לרקמה]',
            'properties[תיק תפילין - שם לרקמה (ראשי תיבות)]'
          ];
        } else {
          labels = [
            'תיק טלית - שם לרקמה',
            'תיק תפילין רש"י - שם לרקמה (ראשי תיבות)',
            'תיק תפילין ר"ת - שם לרקמה (ראשי תיבות)'
          ];
          names = [
            'properties[תיק טלית - שם לרקמה]',
            'properties[תיק תפילין רש"י - שם לרקמה (ראשי תיבות)]',
            'properties[תיק תפילין ר"ת - שם לרקמה (ראשי תיבות)]'
          ];
        }
        var labelEls = root.querySelectorAll('.personalization__emb-item-label');
        labelEls.forEach(function (el, i) {
          if (i < count) el.textContent = labels[Math.min(i, labels.length - 1)];
        });
        embInputs.forEach(function (input, i) {
          if (i < count && names[Math.min(i, names.length - 1)]) {
            input.name = names[Math.min(i, names.length - 1)];
          }
        });
        if (embInputs.length) embInputs[0].maxLength = method === 'emboss' ? 15 : 40;

        // תו בלתי-נראה (‌) בין המספר ל-₪ — כדי ששום סורק מחירים (ממיר
        // המטבעות וכדומה) לא יזהה את הטקסט כמחיר וישכתב אותו
        function ils(n) { return n + '‌ ₪'; }

        var titleTextEl = root.querySelector('.personalization__emb-title-text');
        if (titleTextEl) titleTextEl.textContent = method === 'emboss' ? 'הטבעת שם' : 'רקמה אישית';

        if (embTitlePriceEl) {
          embTitlePriceEl.textContent = method === 'emboss'
            ? '(תוספת ' + ils(conf.embossPrice) + ' לשם)'
            : '(' + ils(conf.letterPrice) + ' לכל אות)';
        }

        if (embPriceEl) {
          if (method === 'emboss') {
            embPriceEl.textContent = 'הטבעת שם — תוספת ' + ils(conf.embossPrice) + '.';
          } else {
            var letters = embCountLetters();
            var base = 'מחיר רקמה: ' + ils(conf.letterPrice) + ' לכל אות (רווחים אינם נספרים).';
            embPriceEl.textContent = letters > 0
              ? base + ' סה"כ: ' + letters + ' אותיות × ' + ils(conf.letterPrice) + ' = ' + ils(letters * conf.letterPrice) + ' ליחידה.'
              : base;
          }
        }
      }

      // הטופס פתוח תמיד — התאמה נחשבת פעילה ברגע שהוקלד משהו באחד השדות
      function isActive() {
        if (group === 'embroidery') {
          var visible = embVisibleInputs();
          for (var j = 0; j < visible.length; j++) {
            if (visible[j].value.trim()) return true;
          }
          return false;
        }
        if (textInput.value.trim()) return true;
        for (var i = 0; i < extraInputs.length; i++) {
          if (extraInputs[i].value.trim()) return true;
        }
        if (dateValue && dateValue.value) return true;
        if (fileInput && fileInput.files.length) return true;
        return false;
      }

      // בקבוצת דפוס: התחלת הקלדה מקפיצה את הכמות למינימום, מחיקה מחזירה
      function syncQuantityMin() {
        if (group !== 'print' || !qtyInput) return;
        if (isActive()) {
          var min = Math.max(minQuantity, parseInt(originalMin, 10) || 0);
          qtyInput.setAttribute('min', String(min));
          if ((parseInt(qtyInput.value, 10) || 0) < min) qtyInput.value = String(min);
        } else {
          if (originalMin !== null) qtyInput.setAttribute('min', originalMin);
          showError('');
        }
      }

      function showError(message) {
        if (!errorEl) return;
        errorEl.textContent = message;
        errorEl.hidden = !message;
      }

      // תאריך עברי נבחר ישירות — יום, חודש ושנה בעברית, בלי לוח לועזי ובלי המרות
      function toHebrewNumeral(n) {
        var L = [[400, 'ת'], [300, 'ש'], [200, 'ר'], [100, 'ק'], [90, 'צ'], [80, 'פ'], [70, 'ע'], [60, 'ס'], [50, 'נ'], [40, 'מ'], [30, 'ל'], [20, 'כ'], [10, 'י'], [9, 'ט'], [8, 'ח'], [7, 'ז'], [6, 'ו'], [5, 'ה'], [4, 'ד'], [3, 'ג'], [2, 'ב'], [1, 'א']];
        var r = '';
        for (var i = 0; i < L.length && n > 0; i++) {
          while (n >= L[i][0]) { r += L[i][1]; n -= L[i][0]; }
        }
        r = r.replace('יה', 'טו').replace('יו', 'טז');
        return r.length === 1 ? r + '׳' : r.slice(0, -1) + '״' + r.slice(-1);
      }

      var hebDay = root.querySelector('.personalization__heb-day');
      var hebMonth = root.querySelector('.personalization__heb-month');
      var hebYear = root.querySelector('.personalization__heb-year');

      if (hebDay && hebMonth && hebYear && dateValue) {
        function fillSelect(select, placeholder, values) {
          var option = document.createElement('option');
          option.value = '';
          option.textContent = placeholder;
          select.appendChild(option);
          values.forEach(function (value) {
            var opt = document.createElement('option');
            opt.value = value;
            opt.textContent = value;
            select.appendChild(opt);
          });
        }

        var hebDays = [];
        for (var d = 1; d <= 30; d++) hebDays.push(toHebrewNumeral(d));

        var hebMonths = ['תשרי', 'חשוון', 'כסלו', 'טבת', 'שבט', 'אדר', 'אדר א׳', 'אדר ב׳', 'ניסן', 'אייר', 'סיוון', 'תמוז', 'אב', 'אלול'];

        var currentHebYear = 5786;
        try {
          currentHebYear = parseInt(new Intl.DateTimeFormat('en-u-ca-hebrew', { year: 'numeric' }).format(new Date()), 10) || 5786;
        } catch (e) { /* ברירת מחדל */ }
        var hebYears = [];
        for (var y = currentHebYear - 1; y <= currentHebYear + 9; y++) hebYears.push(toHebrewNumeral(y - 5000));

        fillSelect(hebDay, 'יום', hebDays);
        fillSelect(hebMonth, 'חודש', hebMonths);
        fillSelect(hebYear, 'שנה', hebYears);

        function updateHebrewDate() {
          if (hebDay.value && hebMonth.value && hebYear.value) {
            dateValue.value = hebDay.value + ' ב' + hebMonth.value + ' ' + hebYear.value;
          } else {
            dateValue.value = '';
          }
        }
        hebDay.addEventListener('change', updateHebrewDate);
        hebMonth.addEventListener('change', updateHebrewDate);
        hebYear.addEventListener('change', updateHebrewDate);
      }

      root.addEventListener('input', syncQuantityMin);
      root.addEventListener('change', syncQuantityMin);
      root.addEventListener('input', refreshEmbroidery);
      root.addEventListener('change', refreshEmbroidery);

      // החלפת מידה (וריאנט) — כל שינוי בשדות המשויכים לטופס מרענן את התצורה
      if (group === 'embroidery') {
        document.addEventListener('change', function (event) {
          var el = event.target;
          if (el && el.getAttribute && el.getAttribute('form') === formId) {
            setTimeout(refreshEmbroidery, 120);
          }
        });
        refreshEmbroidery();
      }

      // האזנה ב-capture על document כדי לרוץ לפני ה-submit של ProductForm בתוך theme.js
      document.addEventListener('submit', function (event) {
        if (event.target !== form) return;

        // אספת כל השדות שנושאים מאפיין (property) שיישלח עם המוצר
        var namedInputs = [textInput];
        extraInputs.forEach(function (input) { namedInputs.push(input); });
        colorInputs.forEach(function (input) { namedInputs.push(input); });
        embInputs.forEach(function (input) { if (namedInputs.indexOf(input) === -1) namedInputs.push(input); });
        methodInputs.forEach(function (input) { namedInputs.push(input); });
        if (phoneInput) namedInputs.push(phoneInput);
        if (fileInput) namedInputs.push(fileInput);

        if (!isActive()) {
          // לא הוקלד כלום — מוסיפים לסל כמוצר רגיל, בלי שום מאפייני הטבעה
          namedInputs.forEach(function (input) { input.disabled = true; });
          hiddenInputs.forEach(function (input) { input.disabled = true; });
          setTimeout(function () {
            namedInputs.forEach(function (input) { input.disabled = false; });
          }, 1500);
          showError('');
          return;
        }

        var text = textInput ? textInput.value.trim() : '';
        var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 0 : 1;
        var variantId = form.id && form.id.value ? form.id.value : '';

        var embConf = null;
        var embMeth = null;
        var embLetters = 0;
        if (group === 'embroidery') {
          embConf = embVariantConf();
          embMeth = embMethod();
        }

        var error = '';
        if (!text) {
          if (group === 'embroidery' && embMeth === 'emboss') error = MESSAGES.missingText.book;
          else error = MESSAGES.missingText[group] || MESSAGES.missingText.book;
        }
        else if (group === 'print' && quantity < minQuantity) error = MESSAGES.minQuantityPrint(minQuantity);
        else if (group === 'print') {
          // מלאי במעקב שאינו מספיק למינימום — Shopify היה מוסיף רק את היתרה, לכן חוסמים מראש
          var stock = inventory[variantId];
          if (stock && stock.managed && stock.policy === 'deny' && stock.qty < minQuantity) {
            error = MESSAGES.insufficientStock(minQuantity, stock.qty);
          }
        }

        if (!error && group === 'embroidery') {
          if (!embConf) error = MESSAGES.feeSetupMissing;
          else if (embMeth === 'emboss' && !embConf.embossFee) error = MESSAGES.feeSetupMissing;
          else if (embMeth === 'embroidery' && !embConf.letterFee) error = MESSAGES.feeSetupMissing;
          else if (embMeth === 'embroidery') {
            embLetters = embCountLetters();
            if (!embLetters) error = MESSAGES.missingText.embroidery;
          }
        }

        if (error) {
          event.preventDefault();
          event.stopPropagation();
          showError(error);
          root.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        showError('');

        // התאמה פעילה — מפעילים את מאפייני המערכת הנסתרים לקראת השליחה
        namedInputs.forEach(function (input) { input.disabled = false; });
        hiddenInputs.forEach(function (input) { input.disabled = false; });

        function muteForSubmit(input) {
          input.disabled = true;
          setTimeout(function () { input.disabled = false; }, 1500);
        }

        // רקמה: וריאנט עמלה, אופן כמות ומספר אותיות לפי המידה והשיטה שנבחרו
        if (group === 'embroidery' && embConf) {
          if (feeVariantInput) feeVariantInput.value = String(embMeth === 'emboss' ? embConf.embossFee : embConf.letterFee);
          if (qtyModeInput) qtyModeInput.value = embMeth === 'emboss' ? 'per-unit' : 'per-letter';
          if (lettersInput) lettersInput.value = String(embLetters || 1);

          // שדות של מידות אחרות ובחירת שיטה שאינה מוצגת — לא נשלחים
          var visibleEmb = embVisibleInputs();
          embInputs.forEach(function (input) {
            if (visibleEmb.indexOf(input) === -1) muteForSubmit(input);
          });
          if (methodWrap && methodWrap.hidden) {
            methodInputs.forEach(function (input) { muteForSubmit(input); });
          }
          if (phoneControl && phoneControl.hidden && phoneInput) muteForSubmit(phoneInput);
        }

        // שדות ריקים לא נשלחים כמאפיינים ריקים בהזמנה
        namedInputs.forEach(function (input) {
          if (input.type !== 'radio' && input.type !== 'file' && !input.disabled && !input.value.trim()) {
            muteForSubmit(input);
          }
        });
        if (dateValue && !dateValue.value) muteForSubmit(dateValue);

        // שדה קובץ ריק נשלח כמאפיין ריק בסל — מנטרלים אותו לרגע השליחה
        if (fileInput && !fileInput.files.length) muteForSubmit(fileInput);

        var keyParts = [text];
        var checkedColor = root.querySelector('.personalization__color-input:checked');
        if (checkedColor) keyParts.push(checkedColor.value);
        extraInputs.forEach(function (input) { keyParts.push(input.value.trim()); });
        if (dateValue && dateValue.value) keyParts.push(dateValue.value);
        if (fileInput && fileInput.files.length) keyParts.push(fileInput.files[0].name);

        if (group === 'embroidery') {
          embVisibleInputs().forEach(function (input, idx) {
            if (idx > 0) keyParts.push(input.value.trim());
          });
          if (phoneInput && phoneControl && !phoneControl.hidden) keyParts.push(phoneInput.value.trim());
          keyParts.push(embMeth || '');
        }

        if (keyInput) keyInput.value = 'p:' + variantId + '|' + group + '|' + keyParts.join('|');
      }, true);
    }

    return { attach: attach };
  })();

  // תוספת בתשלום (למשל אבני סברובסקי): בסימון הצ'קבוקס נשלחים מאפייני הקישור
  // לשורת העמלה; מנוע הסנכרון של הסל מטפל בהוספה, בכמות ובמחיקה
  function attachAddon(root) {
    var formId = root.dataset.formId;
    var form = document.getElementById(formId);
    var checkbox = root.querySelector('.custom-addon__checkbox');
    var hiddenInputs = root.querySelectorAll('input[type="hidden"]');
    var keyInput = root.querySelector('.custom-addon__key');
    var feeInput = root.querySelector('.custom-addon__fee');
    if (!form || !checkbox) return;

    document.addEventListener('submit', function (event) {
      if (event.target !== form) return;
      if (checkbox.checked) {
        hiddenInputs.forEach(function (input) { input.disabled = false; });
        var variantId = form.id && form.id.value ? form.id.value : '';
        if (keyInput) keyInput.value = 'ad:' + variantId + '|' + (feeInput ? feeInput.value : '');
      } else {
        hiddenInputs.forEach(function (input) { input.disabled = true; });
      }
    }, true);
  }

  // כפתורי תמונה: הבחירה מוצגת מעל הגלריה של המוצר כתמונה מלאה
  function attachImageChoice(root) {
    var inputs = root.querySelectorAll('.custom-image-choice__input');
    var selectedLabel = root.querySelector('.custom-image-choice__selected');
    if (!inputs.length) return;

    function galleryWrap() {
      var section = root.closest('.shopify-section') || document;
      return section.querySelector('.product-gallery__media-list-wrapper');
    }

    function apply() {
      var checked = root.querySelector('.custom-image-choice__input:checked');
      if (selectedLabel) selectedLabel.textContent = checked ? checked.value : '';

      var wrap = galleryWrap();
      if (!wrap) return;
      var overlay = wrap.querySelector('.custom-image-choice-overlay');

      if (checked && checked.dataset.image) {
        if (!overlay) {
          overlay = document.createElement('img');
          overlay.className = 'custom-image-choice-overlay';
          wrap.appendChild(overlay);
        }
        overlay.src = checked.dataset.image;
        overlay.alt = checked.value;
        overlay.hidden = false;
      } else if (overlay) {
        overlay.remove();
      }
    }

    inputs.forEach(function (input) { input.addEventListener('change', apply); });

    // לחיצה על תמונה ממוזערת בגלריה מסתירה זמנית את התצוגה כדי לאפשר עיון
    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('.product-gallery__thumbnail')) {
        var wrap = galleryWrap();
        var overlay = wrap && wrap.querySelector('.custom-image-choice-overlay');
        if (overlay) overlay.hidden = true;
      }
    });
  }

  function initForms() {
    document.querySelectorAll('personalization-form:not([data-pers-ready])').forEach(function (root) {
      root.dataset.persReady = 'true';
      PersonalizationForm.attach(root);
    });
    document.querySelectorAll('personalization-addon:not([data-pers-ready])').forEach(function (root) {
      root.dataset.persReady = 'true';
      attachAddon(root);
    });
    document.querySelectorAll('image-choice:not([data-pers-ready])').forEach(function (root) {
      root.dataset.persReady = 'true';
      attachImageChoice(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initForms);
  } else {
    initForms();
  }

  // טפסים שמתווספים דינמית (quick view, עורך ה-Theme, רינדור מחדש של סקשן)
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) { initForms(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* ------------------------------------------------------------------ */
  /* מנוע סנכרון הסל                                                     */
  /* ------------------------------------------------------------------ */

  var reconciling = false;
  var rerunRequested = false;
  var debounceTimer = null;

  function scheduleReconcile(delay) {
    if (reconciling) { rerunRequested = true; return; }
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(runReconcile, typeof delay === 'number' ? delay : 400);
  }

  function cartRequest(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    });
  }

  async function runReconcile() {
    if (reconciling) { rerunRequested = true; return; }
    reconciling = true;
    var changed = false;

    try {
      var cart = await (await fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })).json();
      var items = cart.items || [];

      // רשת ביטחון: שורת הטבעת דפוס שירדה מתחת למינימום (למשל כי Shopify קיצץ
      // את הכמות לפי המלאי) — מנסים להשלים למינימום, ואם אין מלאי מסירים ומודיעים
      var minFixed = false;
      for (var m = 0; m < items.length; m++) {
        var line = items[m];
        var minQ = line.properties ? parseInt(line.properties._pers_min_qty, 10) || 0 : 0;
        if (!minQ || !line.properties._pers_key || line.quantity >= minQ) continue;

        var raised = false;
        try {
          var raiseResp = await cartRequest('/cart/change.js', { id: line.key, quantity: minQ });
          if (raiseResp.ok) {
            var raisedCart = await raiseResp.json();
            var raisedLine = (raisedCart.items || []).filter(function (i) { return i.key === line.key; })[0];
            raised = raisedLine && raisedLine.quantity >= minQ;
          }
        } catch (e) { raised = false; }

        if (!raised) {
          await cartRequest('/cart/change.js', { id: line.key, quantity: 0 });
          alert(MESSAGES.removedFromCart(minQ));
        }
        minFixed = true;
      }

      if (minFixed) {
        changed = true;
        cart = await (await fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })).json();
        items = cart.items || [];
      }

      var parents = items.filter(function (item) { return item.properties && item.properties._pers_key; });
      var fees = items.filter(function (item) {
        return item.product_type === 'SETUP_COST' || (item.properties && item.properties._pers_for);
      });

      // מה אמור להיות בסל: מפתח קישור -> {וריאנט עמלה, כמות, כותרת הורה}
      var expected = {};
      parents.forEach(function (parent) {
        var key = parent.properties._pers_key;
        var mode = parent.properties._pers_fee_qty_mode || 'per-unit';
        var feeVariant = parseInt(parent.properties._pers_fee_variant, 10);
        if (!feeVariant) return;

        if (!expected[key]) expected[key] = { variantId: feeVariant, quantity: 0, title: parent.product_title };
        if (mode === 'once') {
          expected[key].quantity = 1;
        } else if (mode === 'per-letter') {
          // רקמה: עמלה לכל אות — כמות העמלה = אותיות × כמות המוצר
          var letters = parseInt(parent.properties._pers_letters, 10) || 1;
          expected[key].quantity = expected[key].quantity + parent.quantity * letters;
        } else {
          expected[key].quantity = expected[key].quantity + parent.quantity;
        }
      });

      // תוספות בתשלום (_addon_key) — קישור עמלה שני, בלתי תלוי בהטבעה
      items.forEach(function (item) {
        var props = item.properties || {};
        if (!props._addon_key) return;
        var addonVariant = parseInt(props._addon_fee_variant, 10);
        if (!addonVariant) return;

        var addonKey = props._addon_key;
        var addonMode = props._addon_qty_mode || 'per-unit';
        if (!expected[addonKey]) expected[addonKey] = { variantId: addonVariant, quantity: 0, title: item.product_title };
        expected[addonKey].quantity = addonMode === 'once' ? 1 : expected[addonKey].quantity + item.quantity;
      });

      var parentVariantIds = items
        .filter(function (item) { return item.product_type !== 'SETUP_COST'; })
        .map(function (item) { return item.id; });

      for (var i = 0; i < fees.length; i++) {
        var fee = fees[i];
        var ref = fee.properties && fee.properties._pers_for;
        var legacyRef = fee.properties && fee.properties.pc_ref;

        if (ref && expected[ref] && expected[ref].variantId === fee.id) {
          if (fee.quantity !== expected[ref].quantity) {
            await cartRequest('/cart/change.js', { id: fee.key, quantity: expected[ref].quantity });
            changed = true;
          }
          delete expected[ref];
        } else if (legacyRef && parentVariantIds.indexOf(parseInt(legacyRef, 10)) !== -1) {
          if (fee.quantity > 1) {
            await cartRequest('/cart/change.js', { id: fee.key, quantity: 1 });
            changed = true;
          }
        } else {
          // יתום (ההורה הוסר), וריאנט לא תואם, או שורת עמלה שנוספה ידנית
          await cartRequest('/cart/change.js', { id: fee.key, quantity: 0 });
          changed = true;
        }
      }

      var toAdd = Object.keys(expected).map(function (key) {
        return {
          id: expected[key].variantId,
          quantity: expected[key].quantity,
          properties: { _pers_for: key, 'עבור': expected[key].title }
        };
      });

      if (toAdd.length) {
        await cartRequest('/cart/add.js', { items: toAdd });
        changed = true;
      }
    } catch (error) {
      console.error('[personalization] cart sync failed:', error);
    } finally {
      reconciling = false;
    }

    if (changed) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }

    if (rerunRequested) {
      rerunRequested = false;
      scheduleReconcile();
    }
  }

  // כל שינוי בסל, מכל נתיב קוד שהוא (fetch / jQuery-XHR), מפעיל סנכרון
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = originalFetch.apply(this, arguments);
    if (!reconciling && CART_MUTATION_RE.test(url)) {
      result.finally(function () { scheduleReconcile(); });
    }
    return result;
  };

  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (!reconciling && typeof url === 'string' && CART_MUTATION_RE.test(url)) {
      this.addEventListener('loadend', function () { scheduleReconcile(); });
    }
    return originalOpen.apply(this, arguments);
  };

  // נתיב מהיר: הוספה לסל מטופס מוצר
  document.addEventListener('variant:add', function () { scheduleReconcile(50); });

  // ניקוי יתומים גם בטעינת עמוד (למשל אחרי מחיקה דרך /cart/change בקישור)
  scheduleReconcile(800);
})();
